import React, { useState } from "react";
import { useSelector } from "react-redux";

import LoginBlock from "../../shared/user/templates/loginForm";
import Modal from "../../utils/customModal";
import instance from "../../../Redux/api/instance";
import { getEnvironment, getSpk } from "../../../Redux/reducer/env";
import {
  encryptPassword,
  errorContainer,
  loadingHtml,
} from "../../utils/functions";

const defaultModal = { content: null, show: false };

const Credentials = ({ nextStep }) => {
  const [modal, setModal] = useState(defaultModal);
  const { env, spk } = useSelector((state) => ({
    env: getEnvironment(state),
    spk: getSpk(state),
  }));

  const onSubmit = async (refNum, businessId) => {
    setModal({ content: loadingHtml(), show: true });
    try {
      const { data } = await instance.post("/providers/validate-request", {
        referenceNumber: encryptPassword(refNum, spk),
        businessId: encryptPassword(businessId, spk),
      });
      nextStep({ ...data.data, referenceNumber: refNum });
    } catch (error) {
      setModal({
        show: true,
        content: errorContainer(
          "Hubo un problema al iniciar sesión",
          error.response?.data?.notifications[0]?.description ||
            "Número de referencia o Identificación incorrectos.",
          { continueBtn: { action: handleClose, text: "Volver a intentar" } }
        ),
      });
    }
  };

  const handleClose = () => setModal(defaultModal);

  return (
    <div className="login-flex">
      <div className="formulario">
        <h1 className="init_session text-white">Iniciar Sesión</h1>
        <h1 className="line red" />
        <h3 className="info_log text-white">
          Ingrese al sistema con el numero de referencia e Identificación de
          provedor.
        </h3>
        <LoginBlock
          lblUsername="Número de referencia"
          lblUserpass="Identificación"
          lblActionBtn="Confirmar"
          btnAction={onSubmit}
          env={env}
        />
        <Modal show={modal.show} handleClose={handleClose}>
          {modal.content}
        </Modal>
      </div>
    </div>
  );
};

export default Credentials;
